import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/components/layout/header/header.component';
import { FooterComponent } from './shared/components/layout/footer/footer.component';
import { CommonModule } from '@angular/common';
import { GraphqlService } from './core/services/graphql/graphql.service';
import { BrowserCheckService } from './utils/browser-check.service';
import { AllSlugsApiResponse } from './shared/types/all-slugs.types';

@Component({
  selector: 'rsc-asp-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'asp';

  constructor(
    private graphqlService: GraphqlService,
    private browserCheck: BrowserCheckService,
  ) {}

  ngOnInit() {
    this.graphqlService.getAllPageAssemblySlugs().subscribe({
      next: (result: AllSlugsApiResponse) => {
        const items = result.data?.pageAssemblyCollection?.items || [];
        if (this.browserCheck.isBrowser()) {
          sessionStorage.setItem('pageAssemblies', JSON.stringify(items));
        }
      },
      error: (error) => {
        console.error('Error fetching page assembly slugs:', error);
      },
    });
  }
}
